export default [60, 80, 100, 120, 140, 160, 170].map((value) => ({
  value,
  text: value.toString(),
}));
